import React, { useState } from "react";
import CheckboxField from "../../../../aat/components/Forms/fields/CheckboxField";
import Drawer from "../../../../aat/components/UI/Drawer/Drawer";
import { PrimaryButton } from "../../UI/Button/Button";
import Icon from "../../Icon/Icon";

interface MobileCheckboxFilterProps
{
    onSelectionSaved: (options: MobileCheckboxOption[]) => void;
    drawer: boolean;
    closeDrawer: () => void;
    options: MobileCheckboxOption[];
    zIndex: number;
}

export interface MobileCheckboxOption
{
    label: string;
    value: string;
    checked: boolean;
}

// Burde være en stateless
const MobileCheckboxFilter: React.FunctionComponent<MobileCheckboxFilterProps> = (props) =>
{
    const [selection, setSelection] = useState<MobileCheckboxOption[]>([]);
    const [isDirty, setDirty] = useState<boolean>(false);

    const toggleChecked = (show: MobileCheckboxOption) => () =>
    {
        const options = [...props.options];
        const currentShow = options.find(s => s.value === show.value);
        if (currentShow)
        {
            currentShow.checked = !currentShow.checked;
            setSelection(options);
            setDirty(true);
        }
    };

    const onReturn = (event: React.FormEvent<HTMLButtonElement>) =>
    {
        event.preventDefault();
        props.onSelectionSaved(selection);
        props.closeDrawer();
        setDirty(true);
    };

    // check on what type of checbox it is gonna be
    return (
        <Drawer visible={props.drawer} close={props.closeDrawer} placement="right" zIndex={props.zIndex}>

            <div className="drawer__header">
                <span className="h5 mb-0">Forestillinger</span>
            </div>
            <div className="drawer__main drawer__main--minus-header-footer">
                <ul className="drawer__main-ul">
                    {props.options.map((opt, index) => (
                        <li className="drawer__main-li" key={index}>
                            <div className="mobile-filter__checkbox">
                                <CheckboxField
                                    // maybe Label should be on selectedShows instead
                                    label={opt.label}
                                    inputProps={{
                                        // check on specific property instead
                                        checked: opt.checked,
                                        type: "checkbox",
                                    }}
                                    onChange={toggleChecked(opt)}
                                />
                            </div>
                        </li>
                    )
                    )}
                </ul>
            </div>
            <div className="drawer__footer">
                <PrimaryButton className="drawer__footer-btn" type="button" onClick={onReturn} size="small">
                    <span className="drawer__footer-icon-left">
                        {isDirty ? null : <Icon name="arrow-left-line" className="w-4 h-4" />}
                    </span>
                    <span>
                        {isDirty ? "Gem" : "Tilbage"}
                    </span>
                    <span className="drawer__footer-icon-right"></span>
                </PrimaryButton>
            </div>
        </Drawer>
    );
};

export default MobileCheckboxFilter;